import { VehicleType } from "../types/types";

import { atom } from "jotai";

export const homePageVehicleTypeAtom = atom<VehicleType | undefined>(undefined);
